import { appUserRequest } from '@/api/request'
import roomApi from '@/api/room'

export default {
  data() {
    return {
      showNicknameModal: false,
      nicknameInput: '',
      nicknameSubmitting: false
    }
  },
  methods: {
    isLoggedInUser() {
      return !!(localStorage.getItem('appToken') && localStorage.getItem('appUser'))
    },

    openNicknameModal() {
      if (this.showUserMenu !== undefined) this.showUserMenu = false
      this.nicknameInput = this.$store.state.playerName || this.getStoredNickname()
      this.showNicknameModal = true
    },

    getStoredNickname() {
      if (this.currentUser && (this.currentUser.nickname || this.currentUser.username)) {
        return this.currentUser.nickname || this.currentUser.username
      }
      try {
        const profile = JSON.parse(localStorage.getItem('appUser') || 'null')
        if (profile && (profile.nickname || profile.username)) {
          return profile.nickname || profile.username
        }
      } catch (e) {
        // ignore
      }
      return localStorage.getItem('playerName') || ''
    },

    closeNicknameModal() {
      this.showNicknameModal = false
    },

    async submitNicknameChange() {
      if (this.nicknameSubmitting) return
      const name = String(this.nicknameInput || '').trim()
      if (!name) {
        this.$message.info('请输入昵称')
        return
      }
      if (name.length > 10) {
        this.$message.info('昵称最多10个字')
        return
      }

      this.nicknameSubmitting = true
      try {
        if (this.isLoggedInUser()) {
          await appUserRequest('/changenick', { nickname: name })
          const userText = localStorage.getItem('appUser')
          if (userText) {
            const profile = JSON.parse(userText)
            profile.nickname = name
            localStorage.setItem('appUser', JSON.stringify(profile))
          }
          if (this.currentUser) {
            this.currentUser = { ...this.currentUser, nickname: name }
          }
        }

        this.$store.commit('SET_PLAYER_NAME', name)
        localStorage.setItem('playerName', name)

        const myId = this.$store.state.playerId
        const players = this.$store.state.players
        if (Array.isArray(players) && myId) {
          this.$store.commit('SET_PLAYERS', players.map(p => (p.id === myId ? { ...p, name } : p)))
        }

        const room = this.$store.state.multiplayer && this.$store.state.multiplayer.room
        if (room && room.id && myId) {
          const res = await roomApi.updateNickname(room.id, { playerId: myId, playerName: name })
          if (res.success) {
            this.$store.commit('multiplayer/UPDATE_ROOM', res.data)
          } else if (!res.handled) {
            this.$message.error(res.message || '房间内昵称更新失败')
          }
        }

        this.showNicknameModal = false
        this.$message.success('昵称已修改')
      } catch (e) {
        if (!e.handled) this.$message.error(e.message || '修改昵称失败')
      } finally {
        this.nicknameSubmitting = false
      }
    }
  }
}
